import { ViAnswerEngineApiEnum } from '@api/visibilityIntelligence/enums/vi-answer-engine.api.enum';
import { AnswerEngineTypesEnum } from '../enums/answer-engine-types.enum';

export const viApiToEngineType: Record<ViAnswerEngineApiEnum, AnswerEngineTypesEnum> = {
    [ ViAnswerEngineApiEnum.openai]:     AnswerEngineTypesEnum.CHATGPT,
    [ ViAnswerEngineApiEnum.gemini]:     AnswerEngineTypesEnum.GEMINI,
    [ ViAnswerEngineApiEnum.perplexity]: AnswerEngineTypesEnum.PERPLEXITY,
    [ ViAnswerEngineApiEnum.anthropic]:  AnswerEngineTypesEnum.CLAUDE,
    [ ViAnswerEngineApiEnum.xai]:        AnswerEngineTypesEnum.GROK,
};


/** @NOTE The following models are not supported in the Vi Answer Engine Api */
type SupportedEngineType = Exclude<AnswerEngineTypesEnum, AnswerEngineTypesEnum.COPILOT | AnswerEngineTypesEnum.MISTRAL | AnswerEngineTypesEnum.LLAMA>;

export const engineTypeToViApi: Record<SupportedEngineType, ViAnswerEngineApiEnum> = {
    [AnswerEngineTypesEnum.CHATGPT]:    ViAnswerEngineApiEnum.openai,
    [AnswerEngineTypesEnum.GEMINI]:     ViAnswerEngineApiEnum.gemini,
    [AnswerEngineTypesEnum.PERPLEXITY]: ViAnswerEngineApiEnum.perplexity,
    [AnswerEngineTypesEnum.CLAUDE]:     ViAnswerEngineApiEnum.anthropic,
    [AnswerEngineTypesEnum.GROK]:       ViAnswerEngineApiEnum.xai,
};
